export default {
  ABORT: 'ABORT'
}
